module.exports = __webpack_public_path__ + "media/stylesheets/flag-icon-css/flags/1x1/za-3c71a2a22271a414dd3d3b34e95364d3.svg";